// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__2rPpm","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__39VXf"};